import React from "react";

export function enhancedInput({
    WrappedComponent,
    id,
    placeholder,
    inputType,
    label
}: {
    WrappedComponent: any;
    id: string;
    placeholder: string;
    inputType: string;
    label?: string;
}) {
    return class extends React.Component {
        constructor(props) {
            super(props);
        }
        render() {
            const labelEl = label && <label className="label">{label}</label>;
            return (
                <div>
                    {labelEl}
                    <WrappedComponent
                        placeholder={placeholder}
                        inputtype={inputType}
                        givenid={id}
                        {...this.props}
                    />
                </div>
            );
        }
    };
}
